module.exports = __webpack_public_path__ + "static/media/tick-mark-success.a7db819a.png";